import {
  MinusCircleIcon,
  PlusCircleIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import LoadingIcon from "@common/LoadingIcon";
import { TitleWithDivider } from "@common/TitleWithDivider";

import "react-toastify/dist/ReactToastify.css";
import { error_message } from "@constants/Errors";
import pageHeaders from "@constants/PageHeaders";
import WarningModal from "@components/Modals/WarningModal";
import ChangeBroadcastGroupParentModal from "@components/Modals/ChangeBroadcastGroupParentModal";
import { UseYobelyMainPage } from "@pages/YOBELY/YobelyGroupMainPage/hooks/UseYobelyMainPage";

const YobelyMainPage: React.FC = () => {
  const form = UseYobelyMainPage();

  const BroadcastGroupTree = ({ groups }) => {
    const displayTree = (nodes) => {
      return (
        <ul>
          {nodes.map((node) => (
            <li key={node.id} className="node-item ml-2">
              <div className="flex justify-between items-center">
                {node.children.length !== 0 ? (
                  <div
                    className="flex justify-normal items-center"
                    onClick={() => form.toggleExpand(node.id)}
                  >
                    {form.expandedNodes[node.id] ? (
                      <MinusCircleIcon className="mr-5 w-5 h-5 text-mayo-link-text hover:opacity-50" />
                    ) : (
                      <PlusCircleIcon className="mr-5 w-5 h-5 text-mayo-link-text hover:opacity-50" />
                    )}
                    <div className="underline hover:opacity-50 cursor-pointer label-light-blue-xl">
                      [{node.code}] {node.name}
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-normal items-center">
                    <div className="label-light-blue-xl">
                      [{node.code}] {node.name}
                    </div>
                  </div>
                )}

                <div className="flex flex-col sm:flex-row sm:items-center sm:ml-0 ml-4 gap-2 sm:gap-2">
                  <button
                    type="button"
                    className="button-small-red items-end"
                    onClick={() => form.handleOpenDeleteModal(node.id)}
                  >
                    削除
                  </button>

                  {node.parent == null && (
                    <button
                      className="button-small-white items-end"
                      onClick={() => form.handleOpenCreatePage(node.id)}
                    >
                      階層を追加
                    </button>
                  )}

                  <button
                    className="button-confirm items-end font-normal"
                    onClick={() => form.handleOpenEditPage(node.id)}
                  >
                    編集
                  </button>
                </div>
              </div>
              <div className="divider mt-2"></div>
              {node.children &&
                node.children.length > 0 &&
                form.expandedNodes[node.id] && (
                  <div className="ml-10 mt-2">{displayTree(node.children)}</div>
                )}
            </li>
          ))}
        </ul>
      );
    };

    const treeData = form.buildGroupTree(groups);

    return <div>{displayTree(treeData)}</div>;
  };

  return (
    <div className="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
      <TitleWithDivider titleText={pageHeaders.YOBELY.main} useDivider={true} />

      <div className="mt-6 border border-text-field-border rounded-lg bg-white shadow-sm">
        <div className="p-2">
          {form.loading ? (
            <div className="flex justify-center items-center min-h-[20vh]">
              <LoadingIcon />
            </div>
          ) : (
            <div className="flex flex-col">
              <div className="w-full">
                <div className="overflow-y-auto max-h-[70vh] min-h-[20vh] sm:max-h-[60vh] p-2">
                  <button
                    onClick={() => form.handleOpenCreatePage("Master")}
                    className="mb-6 flex items-center p-2 text-sm rounded-lg text-white bg-button-light-blue hover:opacity-70 transition w-50"
                  >
                    <PlusIcon
                      className="w-5 h-5 text-white mr-1"
                      strokeWidth={2.5}
                    />
                    <span className="truncate text-md">
                      一斉発信グループを追加
                    </span>
                  </button>

                  {form.broadcastGroups.length >= 1 ? (
                    <BroadcastGroupTree groups={form.broadcastGroups} />
                  ) : (
                    <div className="mb-5 flex text-center justify-center text-lg font-semibold text-gray-700">
                      {error_message.departments.no_departments}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <WarningModal
        title={form.warningModalTitle}
        body={form.warningModalBody}
        confirmText={form.warningModalConfirm}
        isOpen={form.deleteModalOpen}
        onConfirm={form.handleDelete}
        onRequestClose={form.handleCloseDeleteModal}
      />

      <ChangeBroadcastGroupParentModal
        isOpen={form.parentModalOpen}
        nodeId={form.selectedNodeId}
        onRequestClose={form.handleCloseParentModal}
        onSelectGroup={form.handleConfirmParentModal}
      />
    </div>
  );
};

export default YobelyMainPage;
